import { DateFormat, formatDate } from "common";
import { random } from "lodash";
import React, { ReactNode } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Page } from "./Page";

export const PageNotFound = () => {
    return (
        <Page title="Page Not Found">
            <div className="h-[85vh] w-full space-y-4 px-6 py-10 text-center">
                <div className="text-shadow text-3xl font-semibold">Page not found</div>
                <PageNotFoundIllustration />
            </div>
        </Page>
    );
};

export const PageNotFoundIllustration = () => {
    const history = useHistory();
    const location = useLocation();
    const filename = `${random(1, 30)}.svg`; // Files from error404.fun
    const url = `https://files.xola.com/x2/404/${filename}`;
    // TODO: Log 404 to SL - location, seller

    return (
        <div>
            <img className="max-h-full w-full object-contain" src={url} />

            <div className="flex-1 overflow-hidden text-center">
                <img className="inline-block h-full" src={`https://files.xola.com/x2/404/${filename}`} />
            </div>

            <div className="text-md">
                We could not find the page you’re looking for, check the URL and try again. Go to
                <Link onClick={() => history.push("/dashboard")}>the dashboard</Link>
                or
                <Link onClick={() => history.goBack()}>go back.</Link>
            </div>

            <div className="text-sm text-gray">
                Page: {location.pathname} <strong>at</strong> {formatDate(new Date(), DateFormat.DATE_TIME)}
            </div>

            <div className="text-sm text-gray-dark">
                Page: {location.pathname} <strong>at</strong> {formatDate(new Date(), DateFormat.DATE_TIME)}
            </div>
        </div>
    );
};

const Link = ({ children, onClick }: { children: ReactNode; onClick: () => void }) => {
    return (
        <a className="mx-1 text-primary hover:cursor-pointer hover:underline" onClick={onClick}>
            {children}
        </a>
    );
};
